'use strict';

const { h } = require('phy');

function getImageSource(data, size) {
  const media = data.find(({ mediaType }) => mediaType === 'Logo');

  if (!media) {
    return null;
  }

  return media.mediaUrl.replace('{{options}}', `${size[0]},`);
}

function getImageSources({ data, sourceProperties }) {
  if (!sourceProperties) {
    return [];
  }

  return sourceProperties.map(image =>
    h('source', {
      media: `(max-width: ${image.media}px)`,
      srcset: getImageSource(data, [image.size]),
    })
  );
}

function MerchantLogoImage({
  className = '',
  alt,
  data = [],
  size = [],
  sourceProperties,
  lazyload = true,
}) {
  const imageSource = data && getImageSource(data, size);

  if (!imageSource) {
    return null;
  }

  const imageSources = getImageSources({ data, sourceProperties });

  const imageTags = lazyload
    ? {
        src:
          'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        'data-src': imageSource,
        class: `lazy-load no-bg ${className}`,
      }
    : {
        src: imageSource,
        class: className,
      };

  return h('picture', [
    ...imageSources,
    h('img', {
      ...imageTags,
      alt,
    }),
  ]);
}

module.exports = MerchantLogoImage;
